import { render } from "./SectionUserHead.vue?vue&type=template&id=6a0017d9"
import script from "./SectionUserHead.vue?vue&type=script&lang=js"
export * from "./SectionUserHead.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__